import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import StatusBadge from '../Common/StatusBadge';
import { bookingStatusConfig } from '../../config/statusConfig';

const ViewBookingModal = ({ show, onHide, booking }) => {
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "₹0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (!booking) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Booking Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <small className="text-muted d-block">Booking Number</small>
              <strong>{booking.booking_number}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Customer</small>
              <strong>{booking.customer_name || 'N/A'}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Mobile</small>
              <strong>{booking.customer_mobile || 'N/A'}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Cylinder Type</small>
              <strong>{booking.cylinder_type_name || booking.cylinder_type || 'N/A'}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Booking Date</small>
              <strong>{formatDateTime(booking.booking_date)}</strong>
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-3">
              <small className="text-muted d-block">Status</small>
              <StatusBadge status={booking.booking_status} config={bookingStatusConfig} />
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Quantity</small>
              <strong>{booking.quantity || 1}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Total Amount</small>
              <strong>{formatCurrency(booking.total_amount || 0)}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Payment Status</small>
              <strong className="text-capitalize">{booking.payment_status || 'N/A'}</strong>
            </div>
            {booking.notes && (
              <div className="mb-3">
                <small className="text-muted d-block">Notes</small>
                <p className="mb-0">{booking.notes}</p>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewBookingModal;